import { useState } from 'react';

import { Constants, usePlatformService } from 'core';
import { EarnCTAButton } from 'ui';

import { OnlineShoppingDrawer } from '../../../components/Drawers/OnlineShoppingDrawer';
import { useExtensionAdded } from '../../../hooks/useExtensionAdded';
import useGtmServices from '../../../hooks/useGtmServices';
import chromeExtension from '../../../utils/chromeExtension';

const InstallExtensionEarnCard = () => {
  const GtmService = useGtmServices();
  const Platform = usePlatformService();
  const { showExtensionCTA } = useExtensionAdded();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    GtmService.click(
      () => {
        if (Platform.OS === 'native') return setIsModalOpen(true);
        if (Platform.mobileBrowser == 'ios') return window.open(Constants.AppLinks.appStore);
        if (Platform.mobileBrowser == 'android')
          return window.open(Constants.AppLinks.android_play_store);
        else chromeExtension.download();
      },
      {
        type: 'button',
        action: 'download_app',
        label: 'Get the Extension',
      }
    );
  };

  if (!showExtensionCTA) return null;

  return (
    <>
      <EarnCTAButton type="online" onClick={handleClick} />
      <OnlineShoppingDrawer drawerControl={[isModalOpen, setIsModalOpen]} />
    </>
  );
};

export { InstallExtensionEarnCard };
